import {default as prettyHtml} from "json-pretty-html";

const coreutils = {

    formatJson(text) {
        //return this.formatJson2(text);
        if (typeof text === "string") {
            try {
                if (String(text).includes('{')) {
                    text = String(text)
                        .replaceAll("Login ","")
                        .replaceAll(" OK","");
                    console.log('text:', text);
                    while (String(text).includes('\"')) {
                        text = JSON.parse(text);
                        console.log('parsed:', text);
                    }
                    return JSON.stringify(text,null,2);
                }
                else return String(text).replaceAll("\"\\\"","")
                    .replaceAll("\\\"\"","")
                    .replaceAll("\"","");
            } catch (error) {
                return text;
            }
        }
        else if (typeof text === "object") {
            try {
                return JSON.stringify(text,null,2);
            } catch (error) {
                return text;
            }
        } else {
            try {
                return 'OTH:'+JSON.stringify(text,null,2);
            } catch (error) {
                return text;
            }
        }
    },

    testJSON(text) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    },

    formatJson2(jsonData){
        var prettyHtml = require('json-pretty-html').default;
        var htmlTable = prettyHtml(jsonData);
        //remove the curley brackets and backslash
        let html = htmlTable.toString();
        return html;
    },

    /**
     * Set localStorage
     */
    setLocalStorage(name, content) {
        if (!name) return
        if (typeof content !== 'string') {
            content = JSON.stringify(content)
        }
        return window.localStorage.setItem(name, content)
    },

    /**
     * Get localStorage
     */
    getLocalStorage(name) {
        if (!name) return
        return JSON.parse(window.localStorage.getItem(name))
    },

    /**
     * Clear localStorage
     */
    clearLocalStorage(name) {
        if (!name) return
        return window.localStorage.removeItem(name)
    },

    base64_encode(data) {
        return btoa(data);
        //return Buffer.from(data, 'binary').toString('base64');
    },

    base64_decode(data) {
        return atob(data);
        //return Buffer.from(data, 'base64').toString('binary');
    },

    hex2bin(hex) {
        var length = hex.length / 2;
        var result = new Uint8Array(length);
        for (var i = 0; i < length; ++i) {
            result[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
        }
        return result;
    },

    bin2hex(bin) {
        return Array.from(bin).map(function (x) {
            return x.toString(16).padStart(2, '0');
        }).join('');
    },

    str_pad(str, len, pad_var) {
        return str.padEnd(len, pad_var);
    },

    encode(str, len = 0) {
        str = str.toString().replace(' ', '');//remove spaces
        if (len > 0) {
            if (str.length < (len * 2)) {
                str = this.str_pad(str, (len * 2), 'F');
            }
        }
        return this.base64_encode(this.hex2bin(str));
    },

    decode(str) {
        return this.bin2hex(this.base64_decode(str));
    },

    hex2ascii(str1) {
        var hex = str1.toString();
        var str = '';
        var strItem = ''
        for (var n = 0; n < hex.length; n += 2) {
            strItem = String.fromCharCode(parseInt(hex.substr(n, 2), 16));
            if (strItem.replace(/[^\x00-\x7F]/g, "")) {
                str += strItem
            }
        }
        return str;
    }
}

export default coreutils;